// pin tiles width & height
export const TILE_WIDTH_MOBILE = 414;
export const TILE_HEIGHT_MOBILE = 273;

export const TILE_WIDTH_DESKTOP = 286;
export const TILE_HEIGHT_DESKTOP = 286;

export const PROJECT_TILE_HEIGHT_MOBILE = 273;
export const PROJECT_TILE_HEIGHT_DESKTOP = 190;

export const PROFESSIONAL_TILE_HEIGHT_MOBILE = 221;
export const PROFESSIONAL_TILE_HEIGHT_DESKTOP = 150;

export const PRODUCT_TILE_WIDTH_MOBILE = 204;
export const PRODUCT_TILE_HEIGHT_MOBILE = 204;
export const PRODUCT_TILE_COLOR_COUNT = 4;

export const UPLOAD_TILE_WIDTH_MOBILE = 204;
export const UPLOAD_TILE_HEIGHT_MOBILE = 204;

export const ARCHIZEEN_TILE_WIDTH_MOBILE = 120;

// page layout styles
export const LEFT_SIDE_WIDTH = 310;
export const FILTER_BAR_HEIGHT = 80;
export const MOBILE_FULL_WIDTH = 414;

// board owner & collaborator styles
export const AVATAR_OVERLAY_OFFSET = 8;
export const AVATAR_BG_COLOR = '#D9D9D9'; // can't find in aria
